export default {
  fields: {
    code: 'Código',
    tag: 'Etiqueta',
    type: 'Tipo',
    discount_type: 'Tipo de desconto',
    discount: 'Desconto',
    usage_threshold: 'Limite de utilização',
    quantity: 'Quantidade',
    expires_at: 'Expira',
    customers: 'Clientes',
    purchases: 'Encomendas',
    sales: 'Vendas',
    level: 'Nível',
    max_discount: 'Desconto máximo',
  },
  tags: {
    master: 'Principal',
    campaign: 'Campanha',
    one_time: 'Uma utilização',
  },
  types: {
    single_use: 'Uso único',
    multi_use: 'Uso múltiplo',
    unknown: 'Desconhecido',
  },
  discount_types: {
    fixed_amount: 'Valor fixo',
    percentage: 'Percentagem',
    unknown: 'Desconhecido',
  },
  labels: {
    discount: 'Desconto',
    usage_threshold: 'Limite de utilização',
    company: 'Empresa',
  },
  collecting_emails: {
    description:
      'Aqui pode configurar o código promocional de uso único gerado para novos utilizadores ao registarem-se no site.',
  },
  buttons: {
    edit: 'Editar',
  },
  toasts: {
    successfully_deleted: 'Definições do código promocional eliminadas com sucesso',
    failed_to_load_data: 'Falha ao carregar os dados',
  },
};
